import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../../components/SEOHead';

export default function AccessoPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const schema = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": "Come Si Accede a Vertiix - Percorso di Ingresso",
    "description": "Accesso selettivo a Vertiix: Valutazione del Sistema, Allineamento Strategico, Attivazione Digital Factory. Requisiti: maturità strategica, volontà di controllo, disponibilità al cambiamento. Non si entra comprando, si entra dimostrando coerenza strategica.",
    "author": {
      "@type": "Organization",
      "name": "Vertiix"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Vertiix",
      "logo": {
        "@type": "ImageObject",
        "url": "https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/8bcd864d4791f65d72fa03933fd02f0d.png"
      }
    },
    "datePublished": "2025-01-15",
    "dateModified": "2025-01-15",
    "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/accesso`
  };

  const percorso = [
    {
      numero: '01',
      fase: 'Valutazione del Sistema',
      descrizione: 'Analizziamo lo stato attuale: struttura organizzativa, flussi decisionali, strumenti in uso, capacità di lettura dei dati.',
      durata: '2–3 settimane',
      output: 'Diagnosi completa e valutazione di compatibilità strategica',
      icon: 'ri-search-eye-line'
    },
    {
      numero: '02',
      fase: 'Allineamento Strategico',
      descrizione: 'Definiamo direzione, priorità e governance. Stabiliamo chi decide, come si decide, cosa si misura.',
      durata: '1–2 settimane',
      output: 'Framework decisionale e sistema di controllo condiviso',
      icon: 'ri-compass-3-line'
    },
    {
      numero: '03',
      fase: 'Attivazione Digital Factory',
      descrizione: 'Costruiamo l\'infrastruttura operativa e attiviamo la produzione coordinata. Il sistema diventa operativo.',
      durata: 'Progressiva',
      output: 'Sistema di crescita governabile e scalabile',
      icon: 'ri-rocket-line'
    }
  ];

  const requisiti = [
    {
      titolo: 'Maturità Strategica',
      descrizione: 'Capacità di pensare per sistemi, non per azioni isolate. Visione oltre il breve periodo.',
      icon: 'ri-brain-line'
    },
    {
      titolo: 'Volontà di Controllo',
      descrizione: 'Desiderio di governare la crescita attraverso dati, processi e struttura.',
      icon: 'ri-dashboard-line'
    },
    {
      titolo: 'Disponibilità al Cambiamento',
      descrizione: 'Accettare che il modo attuale di operare possa essere ridisegnato.',
      icon: 'ri-refresh-line'
    },
    {
      titolo: 'Investimento Adeguato',
      descrizione: 'Budget coerente con la costruzione di un sistema, non con l\'acquisto di singole campagne.',
      icon: 'ri-funds-line'
    }
  ];

  const esclusi = [
    'Aziende che cercano "un\'agenzia che esegue"',
    'Chi vuole risultati immediati senza struttura',
    'Organizzazioni senza capacità decisionale chiara',
    'Chi cerca il prezzo più basso',
    'Aziende che non vogliono cambiare processi interni'
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEOHead 
        title="Come Si Accede a Vertiix - Percorso di Ingresso"
        description="Accesso selettivo a Vertiix: Valutazione del Sistema, Allineamento Strategico, Attivazione Digital Factory. Requisiti: maturità strategica, volontà di controllo, disponibilità al cambiamento. Non si entra comprando, si entra dimostrando coerenza strategica."
        keywords="accesso vertiix, valutazione sistema, requisiti digital factory, compatibilità strategica, maturità aziendale, percorso ingresso"
        canonical={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/accesso`}
        ogImage="https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/8bcd864d4791f65d72fa03933fd02f0d.png"
        schema={schema}
      />
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-b border-gray-100 z-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/26134a7c97c7b6c8adda3aad56072f90.png" 
                alt="Vertiix" 
                className="h-16 md:h-24"
              />
            </Link>
            
            {/* Mobile Menu Button */}
            <button 
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            >
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-700`}></i>
            </button>

            {/* Desktop Menu */}
            <div className="hidden md:flex items-center space-x-8">
              <Link to="/" className="text-gray-600 hover:text-teal-600 transition-colors text-sm font-medium">Home</Link>
              <Link to="/problema" className="text-gray-600 hover:text-teal-600 transition-colors text-sm font-medium">Il Problema</Link>
              <Link to="/vertiix" className="text-gray-600 hover:text-teal-600 transition-colors text-sm font-medium">Cos'è Vertiix</Link>
              <Link to="/come-funziona" className="text-gray-600 hover:text-teal-600 transition-colors text-sm font-medium">Come Funziona</Link>
              <Link to="/accesso" className="text-teal-600 text-sm font-medium">Come Si Accede</Link>
              <Link to="/valutazione" className="px-6 py-3 border border-[#14B8A6] text-[#14B8A6] hover:bg-[#14B8A6] hover:text-white transition-all whitespace-nowrap cursor-pointer">VALUTAZIONE</Link>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
            <div className="px-6 py-4 space-y-4">
              <Link to="/" className="block text-sm text-gray-700 hover:text-teal-600 transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>
                Home
              </Link>
              <Link to="/problema" className="block text-sm text-gray-700 hover:text-teal-600 transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>
                Il Problema
              </Link>
              <Link to="/vertiix" className="block text-sm text-gray-700 hover:text-teal-600 transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>
                Cos'è Vertiix
              </Link>
              <Link to="/come-funziona" className="block text-sm text-gray-700 hover:text-teal-600 transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>
                Come Funziona
              </Link>
              <Link to="/accesso" className="block text-sm text-teal-600 font-medium transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>
                Come Si Accede
              </Link>
              <Link to="/valutazione" className="block text-center px-6 py-3 border border-[#14B8A6] text-[#14B8A6] hover:bg-[#14B8A6] hover:text-white transition-all whitespace-nowrap cursor-pointer mt-4" onClick={() => setMobileMenuOpen(false)}>
                VALUTAZIONE
              </Link>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section className="pt-24 md:pt-32 pb-12 md:pb-20 px-6 lg:px-12">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-block px-4 py-1.5 bg-teal-50 text-teal-700 text-sm font-medium rounded-full mb-6">
            Accesso Selettivo
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Come si Accede a Vertiix
          </h1>
        </div>
      </section>

      {/* Messaggio Chiave */}
      <section className="py-12 md:py-16 px-6 lg:px-12 bg-gray-50">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-xl md:text-2xl font-semibold text-gray-900 leading-relaxed">
            Non si entra comprando.<br />
            Si entra dimostrando coerenza strategica.
          </p>
        </div>
      </section>

      {/* Percorso di Ingresso */}
      <section className="py-16 md:py-24 px-6 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 md:mb-6">
              Il Percorso di Ingresso
            </h2>
            <p className="text-base md:text-lg text-gray-600 leading-relaxed max-w-3xl mx-auto">
              Tre fasi sequenziali che trasformano l'interesse in partnership operativa.<br />
              Ogni fase filtra, verifica e prepara la successiva.<br />
              L'accesso non è automatico.
            </p>
          </div>

          <div className="space-y-6 md:space-y-8">
            {percorso.map((step, index) => (
              <div key={step.numero} className="bg-white border-2 border-gray-100 rounded-2xl p-6 md:p-8 lg:p-10 hover:border-teal-200 transition-colors">
                <div className="flex flex-col lg:flex-row gap-6 md:gap-8">
                  {/* Numero e Icona */}
                  <div className="flex-shrink-0">
                    <div className="w-16 h-16 md:w-20 md:h-20 bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl flex items-center justify-center mb-4">
                      <i className={`${step.icon} text-2xl md:text-3xl text-white`}></i>
                    </div>
                    <div className="text-5xl md:text-6xl font-bold text-teal-100 select-none">
                      {step.numero}
                    </div>
                  </div>

                  {/* Contenuto */}
                  <div className="flex-1">
                    <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3 md:mb-4">
                      {step.fase}
                    </h3>
                    <p className="text-base md:text-lg text-gray-600 leading-relaxed mb-4 md:mb-6">
                      {step.descrizione}
                    </p>

                    <div className="grid md:grid-cols-2 gap-4 md:gap-6">
                      <div className="bg-gray-50 p-4 md:p-5 rounded-lg">
                        <div className="text-xs md:text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">
                          Durata
                        </div>
                        <p className="text-sm md:text-base text-gray-900 font-medium">
                          {step.durata}
                        </p>
                      </div>

                      <div className="bg-teal-50 p-4 md:p-5 rounded-lg">
                        <div className="text-xs md:text-sm font-semibold text-teal-700 uppercase tracking-wide mb-2">
                          Output
                        </div>
                        <p className="text-sm md:text-base text-gray-900 font-medium">
                          {step.output}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {index < percorso.length - 1 && (
                  <div className="flex justify-center mt-6 md:mt-8">
                    <div className="w-0.5 h-6 md:h-8 bg-gradient-to-b from-teal-300 to-transparent"></div>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Nota di Chiarimento */}
          <div className="mt-12 text-center">
            <p className="text-sm md:text-base text-gray-500 leading-relaxed max-w-2xl mx-auto">
              Ogni fase conferma o esclude la compatibilità.<br />
              Non tutte le aziende accedono alla fase successiva.
            </p>
          </div>
        </div>
      </section>

      {/* Requisiti */}
      <section className="py-24 px-6 lg:px-12 bg-gradient-to-br from-teal-50 to-white">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Requisiti di Compatibilità
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed max-w-3xl mx-auto">
              Vertiix funziona solo con aziende che possiedono queste caratteristiche.<br />
              Non sono negoziabili.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {requisiti.map((req) => (
              <div key={req.titolo} className="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
                <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center mb-5">
                  <i className={`${req.icon} text-2xl text-teal-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {req.titolo}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {req.descrizione}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Chi Non Viene Accettato */}
      <section className="py-24 px-6 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Chi Non Viene Accettato
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-8">
              Non è una valutazione morale.<br />
              È una questione di modello.
            </p>
          </div>

          <div className="bg-gray-50 rounded-2xl p-10">
            <div className="space-y-5">
              {esclusi.map((item, index) => (
                <div key={index} className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-gray-300 flex items-center justify-center mt-1">
                    <i className="ri-close-line text-sm text-gray-600"></i>
                  </div>
                  <p className="text-lg text-gray-700 leading-relaxed">
                    {item}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-12 text-center">
            <p className="text-gray-600 leading-relaxed max-w-2xl mx-auto">
              Se ti riconosci in uno di questi profili, Vertiix non è la scelta giusta.<br />
              Nessun problema: esistono fornitori più adatti alle tue esigenze.
            </p>
          </div>
        </div>
      </section>

      {/* Immagine Processo */}
      <section className="py-16 md:py-24 px-6 lg:px-12 bg-gray-50">
        <div className="max-w-5xl mx-auto">
          <div className="relative w-full h-[500px] md:h-[600px] rounded-2xl overflow-hidden shadow-xl">
            <img 
              src="https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/ce83de42273e2261289003278b919114.png" 
              alt="Processo di accesso Vertiix"
              className="w-full h-full object-cover object-center"
            />
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 px-6 lg:px-12">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Inizia dalla Valutazione
          </h2>
          <p className="text-lg text-gray-600 mb-10 leading-relaxed max-w-2xl mx-auto">
            La valutazione non è una call di vendita.<br />
            È un'analisi oggettiva della compatibilità strategica.<br />
            L'accesso non è automatico.
          </p>
          <Link 
            to="/valutazione" 
            className="inline-block px-8 py-4 bg-teal-600 text-white text-lg font-semibold rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            Richiedi Valutazione
          </Link>
          <p className="text-sm text-gray-500 mt-6">
            Nessun impegno immediato. Nessuna pressione commerciale.
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1a2332] py-16 md:py-20 px-6 md:px-12">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16 mb-12">
            <div className="md:col-span-4">
              <img 
                src="https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/26134a7c97c7b6c8adda3aad56072f90.png" 
                alt="Vertiix" 
                className="h-48 mb-8"
                style={{ filter: 'drop-shadow(0 0 15px rgba(255, 255, 255, 0.6)) drop-shadow(0 0 30px rgba(255, 255, 255, 0.4)) drop-shadow(0 0 45px rgba(255, 255, 255, 0.3))' }}
              />
              <p className="text-sm text-gray-400 leading-relaxed">Digital Factory per aziende che vogliono governare la crescita, non subirla.</p>
            </div>
            
            <div className="md:col-span-2">
              <h4 className="text-sm font-semibold text-white mb-6">Navigazione</h4>
              <nav className="space-y-3">
                <Link to="/" className="block text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">Home</Link>
                <Link to="/problema" className="block text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">Il Problema</Link>
                <Link to="/vertiix" className="block text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">Cos'è Vertiix</Link>
                <Link to="/come-funziona" className="block text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">Come Funziona</Link>
                <Link to="/accesso" className="block text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">Come Si Accede</Link>
              </nav>
            </div>
            
            <div className="md:col-span-3">
              <h4 className="text-sm font-semibold text-white mb-6">Contatti</h4>
              <p className="text-sm text-gray-400">info@vertiix.ch</p>
            </div>
            
            <div className="md:col-span-3">
              <h4 className="text-sm font-semibold text-white mb-6">Azione</h4>
              <Link to="/valutazione" className="block text-sm text-gray-400 hover:text-[#14B8A6] transition-colors mb-3">Valutazione</Link>
              <Link to="/about-vertiix" className="block text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">About Vertiix</Link>
            </div>
          </div>
          
          <div className="pt-6 sm:pt-7 md:pt-8 border-t border-gray-700 flex flex-col md:flex-row justify-between items-center gap-3 sm:gap-4">
            <p className="text-[10px] sm:text-xs text-gray-500 text-center md:text-left">
              © 2025 Vertiix. Sistema operativo della crescita.
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4">
              <a 
                href="https://ti.chregister.ch/cr-portal/auszug/auszug.xhtml?uid=CHE-410.417.125" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-[10px] sm:text-xs text-gray-500 hover:text-[#14B8A6] transition-colors cursor-pointer"
              >
                CHE-410.417.125
              </a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-[10px] sm:text-xs text-gray-500 hover:text-[#14B8A6] transition-colors">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}